import React from 'react'
import Heading from 'utils/Heading'
import RichText from 'utils/RichText'

const BigTypeStatic = ({blok}) => {

    return (
        <div className="my-12 lg:my-24">
            <div className="mx-auto px-6 lg:px-12">            
                    {/* Split RichText from Paragraphs */}
                    {blok.title.content.map((items, index) => (
                        items.content.map((item) => (   
                            <div className='flex'>                      
                                <Heading size="h1" className={`${index % 2 == 0 ? 'mr-auto' : 'ml-auto'} font-poppins text-primary font-display !text-7xl lg:!text-[13vw]  tracking-normal leading-none !mb-6 `}>
                                    <RichText>
                                        {item.text}
                                    </RichText>
                                </Heading>
                            </div>
                        ))
                    ))
                    }         
            </div>
        </div>
    )
};

export default BigTypeStatic;